import styled from 'styled-components';

export const Page = styled.div`
  background-color: ${({ theme }) => theme.background};
  min-height: 100vh;
`;
